import {
  Component,
  OnInit,
  ElementRef,
  ViewEncapsulation,
} from "@angular/core";

import { LocalizeService } from "../../insa-services";
import { ControlTableService } from "./control-table.service";

@Component({
  selector: "app-control-table-shell",
  templateUrl: "./control-table-shell.component.html",
  styles: [require("./control-table.component.css").toString()],
  encapsulation: ViewEncapsulation.None,
})
export class ControlTableShellComponent implements OnInit {
  constructor(
    private _localize: LocalizeService,
    private _element: ElementRef,
    private _service: ControlTableService,
  ) {}

  ngOnInit(): void {
    this._service.load();
    setTimeout(
      () => this._localize.applyTranslations(this._element.nativeElement),
      0,
    );
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-control-table/control-table-shell.component.ts